<template>
    <div class="ClientServiceLog">
        <div class="row" style="margin-top:5px;">
            <div class="col-sm-3">
                <h2>Child Log <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'download']" v-on:click="DownloadData()" class="pointer" /></h2>
            </div>
            <div class="col-sm-3">
                <button type="button" class="btn btn-success" @click="OpenAddRecord()"><font-awesome-icon :icon="['fa', 'plus']" /> ADD NEW ENTRY</button>
            </div>
        </div>

        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>From:</label>
                        <flat-pickr v-model="Filters.StartDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>To:</label>
                        <flat-pickr v-model="Filters.EndDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Entries:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4"></div>

            </div>
        </form>
        <vuetable :fields="Fields"
                  pagination-path=""
                  :api-mode="false"
                  class="vue-datatable"
                  :data-manager="DataManager"
                  ref="datatable"
                  id="servicelogentriestable"
                  track-by="Id">

            <template slot="EntryDateTime" scope="props">
                <div class="EntryDateTime">
                    <font-awesome-icon v-if="props.rowData.CanEdit && EditMode" :icon="['fa', 'edit']" @click="OpenEditRecord(props.rowData)" class="pointer" /><span>{{ formatEffectiveDateTime(props.rowData.EffectiveDateTime) }}</span>
                </div>
            </template>
            <span><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewDocument(props.rowData.PDFFileID, props.rowData.FormLabel, props.rowData.PDFFileName)" class="pointer" /></span>
            <template slot="EntryNotes" scope="props">
                <div class="EntryNotes">
                    <span v-html="props.rowData.Note"></span> <span v-if="props.rowData.DocumentID"><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewDocument(props.rowData.DocumentPDFFileID, props.rowData.DocumentLabel, props.rowData.DocumentFileName)" class="pointer" /></span>
                </div>
            </template>
        </vuetable>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />

        <!--MODALS-->
        <b-modal ref="addedit-modal" :title="AddEditTitle" hide-footer no-close-on-esc no-close-on-backdrop>
            <b-container>
                <b-form @submit="AddUpdateEntry">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Date:</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="TargetEntry.EffectiveDate" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Time:</label>
                                <flat-pickr class="form-control" :config="TimeConfig" v-model="TargetEntry.EffectiveTime"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Category:</label>
                                <select class="form-control" v-model="TargetEntry.Category" @change="OnCategoryChange" required>
                                    <optgroup v-for="optiongroup in LogCategories" :label="optiongroup.Label">
                                        <option v-for="option in optiongroup.Options" v-bind:value="option.value">
                                            {{ option.value }}
                                        </option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Note:</label>
                                <textarea rows="6" class="form-control" v-model="TargetEntry.Note"></textarea>
                            </div>
                            <div v-if="TargetEntry.Category == 'CPA Family Contact' || TargetEntry.Category == 'CSS Visit'" class="form-group">
                                <label>Mileage:</label>
                                <input type="number" step="0.1" min="0" class="form-control" v-model="TargetEntry.Mileage" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelAddEdit()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="TargetEntry.Id" size="md" variant="danger" type="button" @click="DeleteEntry()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
    </div>
</template>

<script>
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../../services/event-bus.js';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import DocumentViewer from "../../../Core/RecordComponents/DocumentViewer.vue";

    export default {
        created() {

        },
        props: [
            "ChildRecordData"
        ],
        data: function () {
            return {
                TargetEntry: {},
                EntrySchema: {
                    Id: "",
                    ChartID: "",
                    EffectiveDate: "",
                    EffectiveTime: "",
                    EffectiveDateTime: "",
                    Category: "",
                    Note: "",
                    Mileage: null
                },
                AddEditTitle: "",
                NumberOfRecords: 0,
                search: "",
                Filters: {
                    StartDateTime: "",
                    EndDateTime: "",
                },
                EditMode: false,
                Fields: [
                    {
                        name: '__slot:EntryDateTime',
                        title: "Date/Time",
                        sortField: 'EffectiveDateTime',
                    },
                    {
                        name: 'EffectiveDateTime',
                        title: "Date/Time",
                        sortField: 'EffectiveDateTime',
                        callback: 'formatDate|MM/DD/YY',
                        visible: false
                    },
                    {
                        name: 'Category',
                        title: 'Category',
                        sortField: 'Category',
                    },
                    {
                        name: 'EmployeeAuthorName',
                        title: 'Author',
                        sortField: 'EmployeeAuthorName',
                    },
                    {
                        name: '__slot:EntryNotes',
                        title: "Notes",
                        sortField: 'Note',
                    },
                    {
                        name: 'Note',
                        title: "Notes",
                        sortField: 'Note',
                        visible: false
                    }
                ],
                EntryData: [],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                TimeConfig: {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'h:i K'
                },
                
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetEntries(true);

            },
            GetEntries(displayLoad = false) {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/ClientServiceLog/GetEntries", { ClientSubProgramMembershipID: this.ChildRecordData.Id, SubProgramID: this.ChildRecordData.ClientProgramMembership.SubProgramID, StartDateTime: this.Filters.StartDateTime, EndDateTime: this.Filters.EndDateTime }, this.GetEntriesSuccess, () => { }, displayLoad);
            },
            GetEntriesSuccess(response) {
                this.EntryData = response.data.data;
                this.$refs.datatable.refresh();
            },
            DownloadData(displayLoad = false) {
                this.$MasterAPI.ExecuteFileRequest("Foster/ClientServiceLog/DownloadEntries", { ClientSubProgramMembershipID: this.ChildRecordData.Id, SubProgramID: this.ChildRecordData.ClientProgramMembership.SubProgramID, StartDateTime: this.Filters.StartDateTime, EndDateTime: this.Filters.EndDateTime });
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            formatEffectiveDateTime(value) {
                if (value.substring(11) == "00:00:00") {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YY");
                } else {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YY hh:mm A");
                }
            },
            OpenAddRecord() {
                this.AddEditTitle = "Add New Entry";
                this.TargetEntry = JSON.parse(JSON.stringify(this.EntrySchema));
                this.$refs['addedit-modal'].show();
            },
            OpenEditRecord(entryData) {
                if (this.EditMode && entryData.CanEdit) {
                    this.AddEditTitle = "Edit Entry";
                    this.TargetEntry = JSON.parse(JSON.stringify(entryData));
                    this.TargetEntry.EffectiveDate = moment(this.TargetEntry.EffectiveDateTime, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD");
                    this.TargetEntry.EffectiveTime = moment(this.TargetEntry.EffectiveDateTime, 'YYYY-MM-DD HH:mm:ss').format("HH:mm:ss");
                    this.$refs['addedit-modal'].show();
                }

            },
            CancelAddEdit() {
                this.$refs['addedit-modal'].hide();
            },
            AddUpdateEntry(e) {
                e.preventDefault();
                let vm = this;
                vm.TargetEntry.ChartID = vm.ChildRecordData.Id;
                if (vm.TargetEntry.EffectiveTime == null) {
                    vm.TargetEntry.EffectiveDateTime = vm.TargetEntry.EffectiveDate;
                } else {
                    vm.TargetEntry.EffectiveDateTime = vm.TargetEntry.EffectiveDate + " " + vm.TargetEntry.EffectiveTime;
                }
                
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ClientServiceLog/AddUpdateEntry", vm.TargetEntry, this.AddUpdateEntrySuccess, () => { }, true);
            },
            AddUpdateEntrySuccess(response) {
                this.GetEntries(true);
                this.$refs["addedit-modal"].hide();
            },
            DeleteEntry() {
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ClientServiceLog/DeleteEntry", { Id: this.TargetEntry.Id }, this.AddUpdateEntrySuccess, () => { }, true);
            },
            DeleteEntrySuccess(response) {
                this.GetEntries(true);
                this.$refs["addedit-modal"].hide();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.EntryData);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfRecords = visibleData.length;
                return visibleData;
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OnCategoryChange(e) {
                if (this.TargetEntry.Category == "CPA Family Contact" && this.TargetEntry.Note == "") {
                    this.TargetEntry.Note = "Education: \nHealth/Dental: \nChildcare needs: \nParenting Skills: \nCulturally Relevant needs: \nILS:\nOn-Call support needs: \nRespite Care Planning: \nTYP Needs: \nTraining: \nAdditional Notes: \n";
                }
                if (this.TargetEntry.Category == "CSS Visit" && this.TargetEntry.Note == "") {
                    this.TargetEntry.Note = "Education: \nHealth/Dental: \nChildcare needs: \nParenting Skills: \nCulturally Relevant needs: \nILS:\nOn-Call support needs: \nRespite Care Planning: \nCase Aide: \nTraining: \nAdditional Notes: \n";
                }
            },
            
        },
        components: {
            Vuetable,
            flatPickr,
            EditMode,
            DocumentViewer
        },
        computed: {
            IsCaregiverSupport: function () {
                let caregiverSupportSubProgramIDs = ['D9B74D70-B9B0-411C-BC1B-90B608036062',
                    'EACF40B6-EF88-41D0-BE4B-6D4F64950865',
                    '33E864F6-20F5-46A2-B586-1FD174DEFBFA',
                    '130F6819-F937-41A7-8FC0-29E052E1F6CC',
                    '12943A82-3156-4270-91A3-63200C6C4AE9',
                    '3F28D8CE-4CD8-4CC4-9984-9AE0BD645DA0'].map(id => id.toUpperCase());

                let subProgramID = this.ChildRecordData
                    && this.ChildRecordData.ClientProgramMembership
                    && this.ChildRecordData.ClientProgramMembership.SubProgramID;

                return !!subProgramID && caregiverSupportSubProgramIDs.includes(subProgramID.toUpperCase());
            },
            IsPNW: function () {
                let pnwSubProgramIDs = ['36F4A54E-89A7-457B-96CC-105B6038B351', 'E93C7592-EEAD-4921-85AB-3D978BC98CEB', '1FCD0794-F57A-4413-B7A8-8E3BC670EADE'];
                if (pnwSubProgramIDs.includes(this.ChildRecordData.ClientProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            },
            LogCategories: function () {
                let output = [
                    {
                        Label: "Communication",
                        Options: [
                            {
                                value: "Communication With Worker"
                            },
                            {
                                value: "Communication With Child"
                            },
                            {
                                value: "Communication With Biological Family"
                            },
                            {
                                value: "Communication With Foster Family"
                            },
                            {
                                value: "Communication With Caregiver"
                            },
                            {
                                value: "Communication With Other"
                            }
                        ]
                    },
                    {
                        Label: "Contacts",
                        Options: [
                            {
                                value: "Receiving Care Child Contact"
                            },
                            {
                                value: "CPA Family Contact"
                            },
                        ]
                    },
                    {
                        Label: "Events",
                        Options: [
                            {
                                value: "Staffing"
                            },
                            {
                                value: "FTDM"
                            },
                            {
                                value: "Court"
                            }
                        ]
                    },
                    {
                        Label: "Reporting",
                        Options: [
                            {
                                value: "Serious Incident Report"
                            }
                        ]
                    },
                    {
                        Label: "Misc",
                        Options: [
                            {
                                value: "Behavior Related"
                            },
                            {
                                value: "Health Related"
                            },
                            {
                                value: "School Related"
                            },
                            {
                                value: "Goal Achievement / Success"
                            },
                            {
                                value: "Other"
                            },
                        ]
                    },
                ];

                if (this.IsCaregiverSupport) {
                    output.push(
                        {
                            Label: "CAREGIVER SUPPORT CRITICAL DATES",
                            Options: [
                                {
                                    value: "CSS Visit"
                                },
                                {
                                    value: "After-Hours Support (Phone)"
                                },
                                {
                                    value: "After-Hours Support (In Person)"
                                },
                                {
                                    value: "Initial Caregiver Outreach"
                                },
                                {
                                    value: "Initial Social Worker Outreach"
                                },
                                {
                                    value: "Caregiver Consented to Services"
                                },
                                {
                                    value: "Social Worker Informed of Services Starting"
                                },
                                {
                                    value: "Initial CSP Sent to Caregiver"
                                },
                                {
                                    value: "Caregiver Declined Services"
                                },
                                {
                                    value: "CSP Reviewed w/ Caregiver"
                                },
                                {
                                    value: "CSP 90 Day Review"
                                }
                            ]
                        },
                    )
                    let reportingGroup = output.find(g => g.Label === "Reporting");
                    if (reportingGroup) {
                        reportingGroup.Options.push({ value: "Requested Case Aide - Ineligible" });
                    }
                }

                if (!this.IsCaregiverSupport && this.IsPNW) {
                    output.push(
                        {
                            Label: "CPA CRITICAL EVENTS (FOR REPORTING)",
                            Options: [
                                {
                                    value: "Emergent Business Hour Contact (In-Person)"
                                },
                                {
                                    value: "After-Hours Support (Phone)"
                                },
                                {
                                    value: "After-Hours Support (In Person)"
                                }
                            ]
                        },
                    )
                }
                return output;
            }
        },
        mounted() {
            this.Filters.StartDateTime = moment().add(-90, "days").format("YYYY-MM-DD");
            this.Filters.EndDateTime = moment().format("YYYY-MM-DD");
            this.GetEntries();
        }
    }
</script>

<style scoped>
    .EntryNotes {
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;
    }
</style>